import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";


























import { PrimaryLocation } from "../../../../location/types/models/Location";

import LocationFormSelect from "../../../../location/components/location/LocationForm/LocationFormSelect";






import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";














export const initialFormStateFn = () => { return {
    
        
        name: "",
        
    
        
        description: "",
        
    
        
        address: "",
        
    
        
        city: "",
        
    
        
        country: "",
        
    
        
        note: "",
        
    
        
        parentId: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.parentId = PrimaryLocation.fromQuery(location.state?.locationId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        name:
        string()
        .trim()
        .min(1, msg`Name is required`),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
    
        address:
        string()
        .trim()
        .nullish(),
    
    
        city:
        string()
        .trim()
        .nullish(),
    
    
        country:
        string()
        .trim()
        .nullish(),
    
    
        note:
        string()
        .trim()
        .nullish(),
    
    
        parentId:
        string()
                .nanoid(msg`Parent is required`)
                .nullish(),
    
};

export const formSchema = object(formObject);

const LocationAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'name' }
       aria-label="name"
       data-testid="name"
       label={t`Name`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'address' }
       aria-label="address"
       data-testid="address"
       label={t`Address`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'city' }
       aria-label="city"
       data-testid="city"
       label={t`City`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'country' }
       aria-label="country"
       data-testid="country"
       label={t`Country`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'note' }
       aria-label="note"
       data-testid="note"
       label={t`Note`}
       
       type='text'
       
   />
   
   
           
           
   
    
    <LocationFormSelect
        type="dynamicSelect"
        name="parentId"
        label={t`Parent`}
        prefix={prefix}
        required={ false }
    />
   
   
   
           
        </Container>
    )
}

export default LocationAddForm;
